import React from 'react';

import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

import Typography from 'components/Typography';

import checkIcon from './assets/check-icon.svg';
import toggleIcon from './assets/toggle-icon.svg';
import styles from './styles.module.scss';

const SwitchToggle = withStyles((theme) => ({
  root: {
    width: 45,
    height: 22,
    padding: 0,
    margin: theme.spacing(1)
  },
  switchBase: {
    padding: 1,
    color: '#AAAAB9',
    '&$checked': {
      transform: 'translateX(21px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#D03673',
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff'
    }
  },
  thumb: ({ checked }) => ({
    width: 20,
    height: 20,
    backgroundImage: `url(${checked ? checkIcon : toggleIcon})`,
    backgroundPosition: 'center',
    backgroundSize: '75%'
  }),
  track: ({ checked }) => ({
    borderRadius: 13,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: checked ? '#D03673' : '#fafafa',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  }),
  checked: {},
  focusVisible: {}
}))(({ classes, ...props }) => {
  return (
    <div className={styles.switchContainer}>
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked
        }}
        {...props}
      />
      <Typography variant="B-TEXT-1">Share across my district </Typography>
    </div>
  );
});

export default SwitchToggle;
